import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

import Content from '../../common/Content';
import FadeInAnimation from '../../common/FadeInAnimation';
// import AnimationContainer from '../../common/AnimationContainer';

import Color from '../../utils/colors';
import { Font, FontWeight } from '../../utils/fonts';
import mediaWidth from '../../utils/mediaWidth/mediaWidth';

import TeamImg from './assets/team-large.png';

const fadeIn = keyframes`
to {
    right: 0;
    opacity: 1;
  }
`;

class StartScreenTeam extends Component {
    render() {
        const { className } = this.props;

        return (
            <Root className={className}>
                <StyledContent>
                    <FadeInAnimation delay="0.7" duration="0.5">
                        <Headline>Команда</Headline>
                    </FadeInAnimation>
                    <FadeInAnimation delay="0.9" duration="0.5">
                        <Text>
                            Aventica объединяет исследователей,
                            аналитиков, дизайнеров
                            {' '}
                            <Br360 />
                            и IT-разработчиков
                            <br />
                            <br />
                            Мы используем нашу совместную
                            экспертизу
                            {' '}
                            <Br1440 />
                            для развития сервисов,
                            продуктов и брендов
                        </Text>
                    </FadeInAnimation>
                    <ImageWrapperDesktop delay="0" duration="0.5">
                        <Img src={TeamImg} />
                    </ImageWrapperDesktop>
                    <ImageWrapperMobile inverseStartPosition delay="1.5">
                        <Img src={TeamImg} />
                    </ImageWrapperMobile>
                </StyledContent>
            </Root>
        );
    }
}

const Root = styled.div`
    height: ${window.innerHeight}px;

    display: flex;
    align-items: center;

    background: ${Color.TEXT_SECONDARY};
    position: relative;
    
    ${mediaWidth.l} { overflow: hidden; }
`;

const StyledContent = styled(Content)`
    @media (min-width: 1920px) {
        position: relative;
    }
`;

const Headline = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};
    font-size: 40px;
    line-height: 40px;

    color: ${Color.TEXT_PRIMARY};
    text-transform: uppercase;

    margin-bottom: 24px;

    ${mediaWidth.m} {
        width: 460px;

        font-size: 48px;
        line-height: 48px;

        margin-bottom: 32px;
    }

    ${mediaWidth.l} {
        font-size: 48px;
        line-height: 56px;

        margin-bottom: 24px;
    }

    ${mediaWidth.xl} {
        width: 733px;

        font-size: 56px;
        line-height: 64px;

        margin-bottom: 40px;
    }
`;

const Text = styled.div`
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    opacity: 0.64;

    ${mediaWidth.m} {
        width: 435px;

        font-size: 18px;
        line-height: 26px;
    }

    ${mediaWidth.xl} {
        width: 515px;

        font-size: 20px;
        line-height: 28px;
    }
`;

const Br360 = styled.br`

    ${mediaWidth.m} {
        display: none;
    }
`;

const Br1440 = styled.br`
    display: none;
    ${mediaWidth.xl} {
        display: block;
    }
`;

const ImageWrapperMobile = styled(FadeInAnimation)`
    position: absolute;
    bottom: -83px;
    left: calc(50% - 165px);
    
    width: 328px;
    height: 252px;
    
    ${mediaWidth.m} {
        bottom: -215px;
        left: calc(50% - 336px);
        
        width: 672px;
        height: 516px;
    }
    
    ${mediaWidth.l} { display: none; }
`;

const ImageWrapperDesktop = styled.div`
    display: none;
    position: absolute;

    top: calc(50% - 173.5px);
    
    width: 452px;
    height: 347px;
    
    right: -92px;

    opacity: 0;

    animation-name: ${fadeIn};
    animation-duration: 0.7s;
    animation-delay: 0.7s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
    
    ${mediaWidth.l} { display: block; }
    
    ${mediaWidth.xl} {
        top: calc(50% - 287px);
        right: -121px;
        
        width: 747px;
        height: 574px;
    }
    
    @media (min-width: 1920px) {
        right: inherit;
        left: 604px;
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
`;

export default StartScreenTeam;
